import { Moment } from 'moment';

import {
  CruiseIcon,
  CyprusFlightIcon,
  HotelIcon,
  LuggageIcon,
  PlaneLanding,
} from '@assets/icons';
import {
  KidInterface,
  ListingSearchRoomInterface,
} from '@components/ui/search/SearchGuest/ListingSearchGuestInterface';
import { ITabItemProps } from '@components/ui/tab/Tab';
import { validRoomChildAge } from '@components/views/hotel/listing/components/ResponsiveSearch/ResponsiveListingSearchGuest';
import { getNMonthsLater, isInclusivelyAfterDay } from '@utils/dateUtil';

export const BookerTabItems: ITabItemProps[] = [
  {
    title: 'Otel',
    icon: HotelIcon,
    type: 'hotel',
  },
  {
    title: 'Kıbrıs Uçaklı Paket',
    icon: CyprusFlightIcon,
    type: 'cyprus',
    feature: 'logout',
  },
  {
    title: 'Tur',
    icon: LuggageIcon,
    type: 'tour',
  },
  {
    title: 'Uçak',
    icon: PlaneLanding,
    type: 'flight',
  },
  {
    title: 'Gemi',
    icon: CruiseIcon,
    type: 'cruise',
  },
];

export const hotelItemsTOStringify = [
  'rooms',
  'slug',
  'in',
  'text',
  'out',
  'url',
  'id',
  'title',
  'adultCount',
  'childrenList',
  'closable',
  'error',
  'key',
  'ref',
  'age',
  'type',
  'redirectUrl',
];

export const packageItemsTOStringify = [
  'rooms',
  'slug',
  'in',
  'text',
  'out',
  'url',
  'id',
  'title',
  'adultCount',
  'childrenList',
  'closable',
  'error',
  'key',
  'ref',
  'age',
  'type',
  'redirectUrl',
  'departureAirport',
  'airportCode',
  'airportId',
  'airportName',
  'cityCode',
  'cityName',
  'countryCode',
  'countryName',
  'isCity',
];

export const generateSearchRooms = (
  hotelRooms: ListingSearchRoomInterface[],
  withoutRoom?: boolean
) => {
  const rooms = hotelRooms?.map(
    (item: ListingSearchRoomInterface) =>
      `${item?.adultCount}${
        item?.childrenList?.length > 0 ? '_' : ''
      }${item?.childrenList
        ?.map((child: KidInterface) =>
          child?.age
            ?.toString()
            ?.split('/')
            ?.join('-')
            ?.split('-')
            ?.reverse()
            ?.join('-')
        )
        ?.join('_')}`
  );
  let roomUrlStr = '';
  if (withoutRoom) {
    roomUrlStr = `${rooms.join(',')}`;
  } else {
    roomUrlStr = `room=${rooms.join(',')}`;
  }
  return roomUrlStr;
};

// ==========================================
// Validate a children array of type KidInterface
// ==========================================
export const validateChildren = (
  children: KidInterface[] = [],
  maxAge = 15
) => {
  let isValid = true;

  if (!Array.isArray(children)) return false;

  for (const item of children) {
    if (!validRoomChildAge(String(item.age), maxAge)) isValid = false;
  }

  return isValid;
};

// ================================================
// Validate a room array of type ListingSearchRoomInterface
// ================================================
export const validateGuestsChildrenAges = (
  hotelRooms: ListingSearchRoomInterface[],
  maxAge?: number
) => {
  let isError = false;

  for (const item of hotelRooms) {
    if (!validateChildren(item.childrenList, maxAge ?? 15)) isError = true;
  }

  return isError;
};

// ================================================
// Disable dates outside of 1 month range
// ================================================
export const disablePastHotelDatePicker = (
  day: any,
  localStartDate: Moment | null,
  localEndDate: Moment | null
) => {
  if (localStartDate && !localEndDate) {
    return isInclusivelyAfterDay(day, getNMonthsLater(localStartDate, 1));
  }

  return false;
};
